// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { ModuleIdentifier } from "src/app/shared/enums/permissions/permission.enum";

export const environment = {
  production: false,
  appVersion: 'v8.1.8',
  USERDATA_KEY: 'authf649fc9a5f55',
  isMockEnabled: true,
  apiUrl: 'https://lottery.apigateway.dev.solvextk.com',
  cognito: {
    userPoolId: 'us-east-2_FYwy5qAKy',
    userPoolClientId: '4lk03ekclji3bvbjafm749gm9r',
  },
  //Todo:delete
  appThemeName: 'Metronic',
  appPurchaseUrl: 'https://1.envato.market/EA4JP',
  appHTMLIntegration:
    'https://preview.keenthemes.com/metronic8/demo1/documentation/base/helpers/flex-layouts.html',
  appPreviewUrl: 'https://preview.keenthemes.com/metronic8/angular/demo1/',
  appPreviewAngularUrl:
    'https://preview.keenthemes.com/metronic8/angular/demo1',
  appPreviewDocsUrl: 'https://preview.keenthemes.com/metronic8/angular/docs',
  appPreviewChangelogUrl:
    'https://preview.keenthemes.com/metronic8/angular/docs/changelog',
    
  allowedModules: [
    ModuleIdentifier.Dashboard,
    ModuleIdentifier.Consortium,
    ModuleIdentifier.User,
    ModuleIdentifier.Cash,
    ModuleIdentifier.Route,
    ModuleIdentifier.Service,
    ModuleIdentifier.Settings
  ]
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
